export default "__VITE_ASSET__917d7425__"